import type { TWorkplaceFormFields } from 'src/client/entities/creditForm';

export const WorkplaceInfoTexts: Record<keyof TWorkplaceFormFields, string> = {
  employmentType: 'Тип занятости',
  unemploymentReason: 'Причина отсутствия занятости',
  anotherUnemploymentReason: 'Другая причина',
  monthlySalary: 'Ежемесячный доход',
  employerType: 'Тип организации',
  areaOfEmployment: 'Сфера деятельности',
  workPhone: 'Рабочий телефон',
  jobTitle: 'Название должности',
  employerInn: 'ИНН организации',
  lastWorkExperienceStartMonth: 'Месяц и год начала работы',
  workAddress: 'Рабочий адрес',
  workOrganizationName: 'Название организации',
  isWorkOrganizationManuallyFilled: 'Заполнить название организации вручную',
  workLocationRoute: 'route рабочего адреса',
  okved: 'ОКВЭД',
};

export const WorkplaceInfoModalTexts = {
  title: 'Работа',
  description: 'Проверьте, что всё верно, и внесите изменения',
};

export const WorkplaceInfoHintsTexts = {
  lastWorkExperienceStartMonth:
    'Укажите месяц и год начала работы на\u00A0текущем месте. Её можно найти в\u00A0трудовой книжке (например, в\u00A0электронной на Госуслугах) или\u00A0трудовом договоре',
  monthlySalary: 'Укажите ваш реальный доход после\u00A0вычета налогов — банк может попросить подтвердить его',
};
